import api from "./api";

export const authService = {
  login(payload) {
    return api.post("/auth/login", payload);
  },
  register(payload) {
    return api.post("/auth/register", payload);
  },
  refresh(payload) {
    return api.post("/auth/refresh", payload);
  },
  logout(payload) {
    return api.post("/auth/logout", payload);
  },
  forgotPassword(payload) {
    return api.post("/auth/forgot-password", payload);
  },
  resetPassword(payload) {
    return api.post("/auth/reset-password", payload);
  },
  changePassword(payload) {
    return api.post("/auth/change-password", payload);
  },
};
